module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-2-84d5ed9a025e1ce8c456bcbda51c95d8.webp";